import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

function PrivacyPolicy() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="link" onClick={handleShow} className="text-muted p-0">
        Privacy Policy
      </Button>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Privacy Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Information We Collect</h5>
          <p>
            We use Google Analytics and Google AdSense to collect anonymous
            usage data and serve relevant advertisements. This includes:
          </p>
          <ul>
            <li>Pages visited and time spent on each page</li>
            <li>Features and calculators used</li>
            <li>Basic device information (browser type, device type)</li>
            <li>Anonymous usage patterns</li>
            <li>Ad interaction data</li>
          </ul>

          <h5>Google AdSense</h5>
          <p>
            We use Google AdSense to display advertisements. Google AdSense may
            use cookies and web beacons to:
          </p>
          <ul>
            <li>
              Serve personalized ads based on your previous visits and interests
            </li>
            <li>Measure ad performance and effectiveness</li>
            <li>Prevent showing the same ads too many times</li>
            <li>Ensure proper ad delivery and reporting</li>
          </ul>
          <p>
            You can learn more about Google AdSense's data practices and opt out
            of personalized advertising by visiting{" "}
            <a
              href="https://policies.google.com/technologies/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google's Ads Settings
            </a>
            .
          </p>

          <h5>How We Use Your Information</h5>
          <p>The collected data is used to:</p>
          <ul>
            <li>Improve our application and understand user behavior</li>
            <li>Display relevant advertisements</li>
            <li>Optimize user experience</li>
            <li>Analyze feature usage and performance</li>
          </ul>

          <h5>Cookies</h5>
          <p>This site uses cookies for:</p>
          <ul>
            <li>Google Analytics tracking</li>
            <li>Google AdSense advertising</li>
            <li>Remembering your theme preference (dark/light mode)</li>
          </ul>

          <h5>Third-Party Services</h5>
          <p>We use the following third-party services:</p>
          <ul>
            <li>Google Analytics (GA4) for website analytics</li>
            <li>Google AdSense for displaying advertisements</li>
          </ul>
          <p>
            These services have their own privacy policies and cookie usage
            which you can review on their respective websites.
          </p>

          <h5>Your Choices</h5>
          <p>You can:</p>
          <ul>
            <li>Opt out of Google Analytics through Google's browser add-on</li>
            <li>Manage your ad preferences through Google's Ad Settings</li>
            <li>Clear your browser cookies and local storage</li>
            <li>Use your browser's "Do Not Track" settings</li>
          </ul>

          <h5>Contact</h5>
          <p>
            If you have any questions about this privacy policy or our data
            practices, please contact us.
          </p>

          <h5>Updates to This Policy</h5>
          <p>
            We may update this privacy policy from time to time. The latest
            version will always be posted on this page.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PrivacyPolicy;
